import { createSelector } from 'reselect';
import { trackGridSort, trackGridFilter } from 'analytics/recipes-tracking';
import { DEFAULT_SORT_BY } from './constants';

export const getFilters = createSelector(
  v => v,
  searchParams => {
    const filters = [];

    searchParams.forEach((value, key) => {
      if (key.endsWith('_flt')) {
        filters.push({
          title: key.replace('_flt', ''),
          values: value.split(','),
        });
      }
    });

    return filters;
  },
);

export const getIsFiltered = searchParams => {
  return !!getFilters(searchParams).length;
};

export const buildParamsForRequest = (search, defaultSortBy = DEFAULT_SORT_BY) => {
  const isDefaultLink = search === '';
  const searchParams = new URLSearchParams(search);
  const filtersGTM = [];
  let sortBy = defaultSortBy;
  let paginationPage = -1;
  let hasPageParam = false;
  let startPage = null;
  let isSorted = false;
  let isFiltered = false;
  let isReset = false;

  const filters = getFilters(searchParams);

  searchParams.forEach((value, key) => {
    if (key.endsWith('_flt')) {
      filtersGTM.push(`${key.replace('_flt', '')}: ${value}`);

      isFiltered = true;
      isReset = false;
    }

    if (key.includes('sortBy')) {
      sortBy = value;
      isSorted = true;
    }

    if (key.includes('page')) {
      paginationPage = value;
      hasPageParam = true;
    }

    if (key === 'startPage') {
      startPage = +value;
    }
  });

  if (
    filters.length === 0 &&
    !isFiltered &&
    !isReset &&
    !isSorted &&
    paginationPage < 1 &&
    !isDefaultLink &&
    !startPage
  ) {
    return false;
  }

  if (filtersGTM.length > 0) {
    trackGridFilter(filtersGTM);
  }

  if (isSorted && !isDefaultLink) {
    trackGridSort(sortBy);
  }

  return {
    filters,
    sortBy,
    paginationPage,
    hasPageParam,
    startPage,
  };
};
